import { render, staticRenderFns } from "./artist-talent-video-detail.vue?vue&type=template&id=45bae38d&scoped=true"
import script from "./artist-talent-video-detail.vue?vue&type=script&lang=js"
export * from "./artist-talent-video-detail.vue?vue&type=script&lang=js"
import style0 from "./artist-talent-video-detail.vue?vue&type=style&index=0&id=45bae38d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bae38d",
  null
  
)

export default component.exports